import React from 'react'

import Broken from '../Errors/Broken'
import Inactive from '../Errors/Inactive'
import MissingPeriodSetting from '../Errors/MissingPeriodSetting'
import NoData from '../Errors/NoData'
import NoDefinition from '../Errors/NoDefinition'
import NoSlice from '../Errors/NoSlice'
import NoTarget from '../Errors/NoTarget'

import { TCoreWidget, TWidgetStatus } from 'types/GlobalWidget'

interface DashboardWidgetErrorProps {
  embedded: boolean
  fetchWidgetData?: (widget: TCoreWidget) => void
  isAdmin: boolean
  onOpenSettings: () => void
  scaleFactor: number
  errorStatus: TWidgetStatus
  widget: TCoreWidget
}

const DashboardWidgetError = (props: DashboardWidgetErrorProps) => {
  const {
    embedded,
    fetchWidgetData,
    isAdmin,
    onOpenSettings,
    scaleFactor,
    errorStatus,
    widget
  } = props

  if (errorStatus.broken) {
    if (errorStatus.missing_data_metrics.length) {
      return (
        <NoData
          embedded={embedded}
          metrics={errorStatus.missing_data_metrics}
          scaleFactor={scaleFactor}
        />
      )
    }

    if (errorStatus.inactive_metrics.length) {
      return (
        <Inactive
          embedded={embedded}
          inactive={errorStatus.inactive_metrics}
          scaleFactor={scaleFactor}
        />
      )
    }

    if (errorStatus.missing_target_metrics.length) {
      return (
        <NoTarget
          embedded={embedded}
          metrics={errorStatus.missing_target_metrics}
          scaleFactor={scaleFactor}
        />
      )
    }

    if (errorStatus.required_slice_missing) {
      return (
        <NoSlice
          embedded={embedded}
          isAdmin={isAdmin}
          onOpenSettings={onOpenSettings}
          scaleFactor={scaleFactor}
        />
      )
    }

    if (errorStatus.required_definition_missing) {
      const { kpi_template_id } = errorStatus.required_definition_missing

      return (
        <NoDefinition
          embedded={embedded}
          fetchWidgetData={fetchWidgetData}
          kpiTemplateId={kpi_template_id}
          scaleFactor={scaleFactor}
          widget={widget}
        />
      )
    }

    if (errorStatus.missing_period_setting) {
      return (
        <MissingPeriodSetting embedded={embedded} scaleFactor={scaleFactor} />
      )
    }

    // unknown error
    return (
      <Broken
        fetchWidgetData={fetchWidgetData}
        scaleFactor={scaleFactor}
        widget={widget}
      />
    )
  }

  return null
}

export default DashboardWidgetError
